export const InstallSync = {
  P: {
    color: 'gray8',
    margin: '0',
    text: '3. Run CLI tool to synchronize:',
  },
  Terminal: {
    width: 'fit-content',
    margin: 'A 0 Z -Y',
    value: (el) => {
      const pkg = el.getRootState?.()?.pkgManager
      return pkg === 'npm' ? 'npm i @symbo.ls/cli -g'
        : pkg === 'yarn' ? 'yarn add smbls global'
        : pkg === 'pnpm' ? 'pnpm add smbls global'
        : 'npm i @symbo.ls/cli -g'
    },
  },
  Flex: {
    gap: 'C1',
    TerminalWithTitle_fetch: {
      margin: 'A - -',
      Title: {
        text: 'One-time fetch:',
      },
      Terminal: {
        margin: '0 0 0 -Y',
        value: 'smbls fetch',
      },
    },
    TerminalWithTitle_sync: {
      margin: 'A - -',
      Title: {
        text: 'Listening changes:',
      },
      Terminal: {
        margin: '0 0 0 -Y',
        value: 'smbls sync',
      },
    },
  },
};